import { useNavigate } from "react-router-dom";
import i18n from "../../constants/i18n";
import Et3Button from "../../core/et3-button";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Margin from "../../core/et3-ui/ET3Margin";
import getUserStore from "../../stores/user-store";
import { TUserSearchForm } from "../../Types";
import React from "react";
import Et3TextInput from "../../core/et3-input/et3-text-input";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import ET3Div from "../../core/et3-div";
import UserSearchPlatForm from "./UserSearchPlatForm";
import UserSearchLimit from "./UserSearchLimit";

const UserSearchForm = withLiteObserverAndTheme<TUserSearchForm>((props) => {
  const { onClickAction, disabled, withLimit, withPlatform, theme } = props;
  const { colors } = theme;
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          icon={faUser}
          type={"number"}
          label={i18n.get("USER_ID")}
          placeHolder={i18n.get("USER_ID")}
          value={getUserStore().userIdInput.get()}
          onChoose={(value: number) => {
            getUserStore().userIdInput.set(value);
          }}
          onBlur={() => {}}
          style={{}}
          onEnter={onClickAction}
        />
        <UserSearchPlatForm withPlatform={withPlatform} />
        <UserSearchLimit withLimit={withLimit} />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={!disabled}
        onClick={() => {
          onClickAction();
          navigate({
            pathname: window.location.pathname,
            search: `?id=${getUserStore().userIdInput.get()}`
          });
        }}
        size="LARGE"
        text="GET"
        type="GET"
      />
    </React.Fragment>
  );
});
export default UserSearchForm;
